import _ from "vendor/lodash";
import spartaEventsUtility from "global/sparta-events-utility";
import spartaGlobalFunctions from "global/sparta-global-functions-utility";




function _uuidString() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}




function _getEnv() {
  const url = window.location.hostname;
  let result = { environment: 'PROD', isLLE: false };

  const cases = {
    cert: {
      environment: 'CERT',
      isLLE: true,
    },
    sit: {
      environment: 'SIT',
      isLLE: true,
    },
    dev: {
      environment: 'DEV',
      isLLE: true,
    },
    '127.0.0.1': {
      environment: 'LOCAL',
      isLLE: true,
    },
    localhost: {
      environment: 'LOCAL',
      isLLE: true,
    },
  };

  if (cases[url]) {
    result = cases[url];
  }

  if (window.location.protocol === 'file:') {
    result = cases.localhost;
  }

  return result;
}

const _store = {};

const EVENTS = {
  ADD_PERSISTED: 'ADD_PERSISTED.spartaStoreUtility',
  REMOVE_PERSISTED: 'REMOVE_PERSISTED.spartaStoreUtility',
  UPDATE_PERSISTED: 'UPDATE_PERSISTED.spartaStoreUtility',
};

class SpartaStoreUtility {




  constructor() {
    this._key = 'sparta';
    window.sparta.store = window.sparta.store || {};
    _store.bankHolidays = [
      '09/05/2016', '10/10/2016', '11/11/2016', '11/24/2016', '12/26/2016',
      '01/02/2017', '01/16/2017', '02/20/2017', '05/29/2017', '07/04/2017',
      '09/04/2017', '10/09/2017', '11/11/2017', '11/23/2017', '12/25/2017',
      '01/01/2018', '01/15/2018', '02/19/2018', '05/28/2018', '07/04/2018',
      '09/03/2018', '10/08/2018', '11/12/2018', '11/22/2018', '12/25/2018'
    ];
    _store.browser = {};
    _store.currentMQ = {
      orientation: null,
      resolution: null,
      viewport: null,
    };

    const lang = document.querySelector('html').getAttribute('lang');

    _store.environment = _getEnv().environment;
    _store.isLLE = _getEnv().isLLE;
    _store.lang = lang ? lang.toLowerCase() : 'en-us';
    _store.jcrLang = _store.lang.split('-')[0];
    _store.state = this._getState();
    _store.useLocalStorage = this.checkStorage('localStorage');
    _store.useSessionStorage = this.checkStorage('sessionStorage');
  }

  get EVENTS() {
    return EVENTS;
  }





  checkStorage(storageType) {
    let checkStorage = false;

    try {
      const uid = new Date;
      const storage = window[storageType];

      storage.setItem(uid, uid);
      checkStorage = storage.getItem(uid) === uid.toString();
      storage.removeItem(uid);
    } catch (exception) {
      console.warn(`storeUtility: ${storageType} access is unavailable.`);
    }

    return checkStorage;
  }






  persist(key, value = {}, storageType = 'localStorage') {
    if (!_store.useLocalStorage || !_store.useSessionStorage || storageType.toLowerCase() === 'object') {
        return this.addData(key, value, false);
    }

    const storage = window[storageType];
    const storageData = storage.getItem(this._key);
    const data = (storageData === null) ? {} : JSON.parse(storageData);
    data[key] = value;
    storage.setItem(this._key, JSON.stringify(data));

    spartaEventsUtility.pub(this.EVENTS.ADD_PERSISTED, { key, value });
  }





  getPersisted(key = null, storageType = 'localStorage') {
    if (!_store.useLocalStorage || !_store.useSessionStorage || storageType.toLowerCase() === 'object') {
      return this.getData(key);
    }

    const storage = window[storageType];
    const storageData = storage.getItem(this._key);
    const data = (storageData === null) ? {} : JSON.parse(storageData);

    return data[key];
  }





  removePersisted(key = null, storageType = 'localStorage') {
    if (!_store.useLocalStorage || !_store.useSessionStorage || storageType.toLowerCase() === 'object') {
      return this.removeData(key, false);
    }

    const storage = window[storageType];
    const storageData = storage.getItem(this._key);
    const data = (storageData === null) ? {} : JSON.parse(storageData);
    let isRemoved = false;
    let removedItem;

    if (!key) {
      storage.removeItem(this._key);
      isRemoved = true;
      removedItem = storageData;
    } else if (data.hasOwnProperty(key)) {
      removedItem = data[key];
      delete data[key];
      storage.setItem(this._key, JSON.stringify(data));
      isRemoved = true;
    }

    spartaEventsUtility.pub(this.EVENTS.REMOVE_PERSISTED,
      Object.assign({ key, isRemoved }, isRemoved && { removedItem }));

    return isRemoved;
  }







  updatePersisted(key, newValue = {}, storageType = 'localStorage') {
    if (!_store.useLocalStorage || !_store.useSessionStorage || storageType.toLowerCase() === 'object') {
      return this.updateData(key, newValue, false);
    }

    const storage = window[storageType];
    const storageData = storage.getItem(this._key);
    const data = (storageData === null) ? {} : JSON.parse(storageData);
    let isUpdated = false;
    let oldValue;

    if (data.hasOwnProperty(key)) {
      oldValue = data[key];
      data[key] = newValue;
      storage.setItem(this._key, JSON.stringify(data));
      isUpdated = true;
    }

    spartaEventsUtility.pub(this.EVENTS.UPDATE_PERSISTED, Object.assign({ key, newValue, isUpdated }, isUpdated && { oldValue }));
      return isUpdated;
  }








  addData(key, val, pubEvent = true) {
    const existing = _.get(_store, key, null);
    let added = false;

    if (existing !== null) {
      this.updateData(key, val);
    } else {
      _.set(_store, key, val);


      (key === 'state') && this._setState(val);

      added = true;
      if (pubEvent) {
        spartaEventsUtility.pub(`${key}-spartaStore`, { action: 'add', data: _.get(_store, key, null) });
      }
    }

    return added;
  }








  updateData(key, val, pubEvent = true) {
    let updated = false;

    _.set(_store, key, val);


    (key === 'state') && this._setState(val);

    updated = true;

    if (pubEvent) {
       spartaEventsUtility.pub(`${key}-spartaStore`, { action: 'update', data: _.get(_store, key, null) });
    }

    return updated;
  }






  getData(key) {
    let data = _.get(_store, key, null);
    if (!key) {
      data = _store;
    }

    return data;
  }







  removeData(key, pubEvent = true) {
    const removedItem = _.get(_store, key, null);
    const removed = _.unset(_store, key);

    if (pubEvent) {
      spartaEventsUtility.pub(`${key}-spartaStore`, { action: 'remove', data: { removed, removedItem } });
    }

    return removed;
  }

















  _getState() {
    let state = '';

    if (_store.environment === 'LOCAL' && _store.useSessionStorage) {
      const sessionStorageState = this.getPersisted('spartaState', 'sessionStorage');
      if (sessionStorageState) {
        state = sessionStorageState;
      }
    } else {

      state = spartaGlobalFunctions.spartaGetCookie('state');
    }

    if (typeof state !== 'string' && state.length !== 2) {
      state = '';
    }

    return state;
  }






  getUserSelectedState() {
    return this._getState()
  }







  _setState(state) {
    if (typeof state !== 'string' && state.length !== 2) {
      return false;
    }

    if (_store.environment === 'LOCAL' && _store.useSessionStorage) {
      this.persist('spartaState', state, 'sessionStorage');
    } else {

      spartaGlobalFunctions.spartaSetCookie('state', state, 365, true);
    }

    return state;
  }
}

export default new SpartaStoreUtility();
